// src/components/SkiperBanner.jsx
import React from 'react';
import '../../styles/components/_skiperbanner.scss';
import skipy from '../../images/skipy.png';
import { Link} from 'react-router-dom';

const SkiperBanner = () => (
  <section className="skiper-banner">
    <div className="content">
      <h2>Meet S.K.I.P.E.R.</h2>
      <p>
        S.K.I.P.E.R.: Robotic Manta Ray designed for Antarctic Exploration. Discover how our innovative technology is revolutionizing underwater exploration in extreme conditions.
      </p>

      <Link to="/projects" className="button">
        View S.K.I.P.E.R.
      </Link>
    </div>
    <div className="image">
      <img src={skipy} alt="Skiper Project" />
    </div>
  </section>
);

export default SkiperBanner;
